import client from '../httpClient';

const directGetDetailApi = (param) => {
  return client.get(`/directs/${param}`);
};

export default directGetDetailApi;
